<button class="dxk-menu-toggle" matTooltip="Collapse/expand menu"
        (click)="sideNavService.toggle()">
  <span class="dxk-menu-toggle-icon"></span>
  <span>MENU</span>
</button>
